import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import $glEventHub from '@/services/$glEventHub'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  // state
  state: {
    user: null,
    group: null,
    config: null,
    dashboard: {
      meta: null,
      is404: false,
      isLoading: true
    },
    groups: {
      user: []
    },
    dashboards: {
      all: [],
      active: [],
      byGroup: [],
      types: []
    }
  },

  // getters
  getters: {
    user (state) {
      return state.user
    },
    group (state) {
      return state.group
    },
    config (state) {
      return state.config
    },
    dashboard (state) {
      return state.dashboard
    },
    groups (state) {
      return state.groups
    },
    dashboards (state) {
      return state.dashboards
    },
    users (state) {
      return state.users
    },
    isLoggedIn (state) {
      return (_.isObject(state.user) && !_.isUndefined(state.user.email))
    }
  },

  // mutations
  mutations: {
    user (state, user) {
      // set user
      state.user = user
    },
    group (state, group) {
      // set group
      state.group = group

      // set dashboards by group
      this.commit('bindDashboard')
    },
    config (state, config) {
      // set config
      state.config = config

      // emit app wide event
      $glEventHub.$emit('store.config.commit')
    },
    dashboard (state, dashboard) {
      // set dashboard
      state.dashboard = dashboard
    },
    userGroups (state, groups) {
      // set user groups
      state.groups.user = groups
    },
    activeDashboards (state, activeDashboards) {
      // set active dashboards
      state.dashboards.active = activeDashboards

      // set dashboards by group
      this.commit('bindDashboard')
    },
    allDashboards (state, allDashboards) {
      state.dashboards.all = allDashboards

      // reset dashboard types
      state.dashboards.types = []

      // if config
      if (_.isObject(state.config) && _.isObject(state.config.agency)) {
        // if mode/periscope -> add mode/periscope to dashboards.types
        if (state.config.agency.modeOrganization) state.dashboards.types.push('mode')
        if (state.config.agency.periscopeApiKey) state.dashboards.types.push('periscope')
      }
    },
    bindDashboard (state) {
      // if: dashboards.active is empty -> empty dashboards.byGroup too
      // else if: dashboards.active is populated AND state has a group -> filter dashboards by group
      if (!state.dashboards.active.length) state.dashboards.byGroup = []
      else if (_.isObject(state.group)) state.dashboards.byGroup = _.filter(state.dashboards.active, { groupId: state.group.id })

      // if no dashboards.byGroup found -> dashboard.is404 is true
      state.dashboard.is404 = (state.groups.user.length && state.dashboards.byGroup.length === 0)

      // if 404 or meta -> stop loading
      if (state.dashboard.is404 || _.isObject(state.dashboard.meta)) state.dashboard.isLoading = false
    },
    logout () {
      // commit reset store
      this.commit('user', null)
      this.commit('group', null)
      this.commit('dashboard', {
        meta: null,
        is404: false,
        isLoading: true
      })
      this.commit('userGroups', [])
      this.commit('allDashboards', [])
      this.commit('activeDashboards', [])
    }
  },

  // plugins
  plugins: [ persistedState() ]
})



// WEBPACK FOOTER //
// ./src/store/index.js